import Header from '@/components/Header';
import Footer from '@/components/Footer';
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { AuthOnly, useAuth } from '@/contexts/auth-context';
import CreateOrganizationForm from '@/components/CreateOrganizationForm';
import { PageHero, pageBg, wrap } from '@/components/ui/design';

export default function CreateOrganization() {
    const { isAuthenticated, isLoading } = useAuth();
    const navigate = useNavigate();

    useEffect(() => {
        if (!isLoading && !isAuthenticated) {
            navigate('/login');
        }
    }, [isLoading, isAuthenticated, navigate]);

    if (!isAuthenticated && !isLoading) return null;

    return (
        <AuthOnly>
            <div className={`min-h-screen flex flex-col ${pageBg}`}>
                <Header />
                <main className="flex-1 overflow-x-clip">
                    <PageHero
                        eyebrow="Organizations"
                        title="Create your organization"
                        subtitle="Set up your public profile, add your brand visuals and invite your team."
                    />
                    <div className={`${wrap} pb-16 pt-10 sm:pb-24`}>
                        <CreateOrganizationForm />
                    </div>
                </main>
                <Footer />
            </div>
        </AuthOnly>
    );
}

